// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.multiselect-order-list .v-select__slot {\n  margin: 0.3rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
